// extracted by mini-css-extract-plugin
module.exports = {"sub-title":"ResetPassword_sub-title__HIv8B","errorMessage":"ResetPassword_errorMessage__3yw-M","return-login":"ResetPassword_return-login__55leW"};